












import Vue from 'vue';
import Component from 'vue-class-component';
import UserApi from '@/api/UserApi';
import {Prop} from 'vue-property-decorator';
import {UserSponsorRetrieveResponse} from '../../model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';

@Component
export default class CompanySelectInput extends Vue {
    @Prop({default: null}) private readonly userKey: number;
    @Prop({default: null}) private readonly sponsorKey: number;
    @Prop({default: 'small'}) private readonly size: string;
    private sponsors: UserSponsorRetrieveResponse[] = [];
    
    get value() {
        return this.sponsorKey;
    }

    get selectSize() {
        return this.size;
    }
    
    public mounted() {
        UserApi.retrieveUserSponsors(this.userKey).then(res => {
            this.sponsors = res.data.sponsorList;
        });
    }
    
    public onChangeInput(data: any) {
        this.$router.push({
            name: 'Home',
            params: {
                ...ApiUtils.extractRequiredParams(this.$route.params),
                sponsorKey: data
            }
        });
    }
}
